import React, { useState, useEffect } from "react";
import { Button, Form, Alert } from "react-bootstrap";
import styles from "./ForgotRequest.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import config from "../../../settings/config";
import { useToast } from "../../../context/ToastContext";

const ForgotRequest = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [successButton, setSuccessButton] = useState(false);
    const { setToast } = useToast();

    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    useEffect(() => {
        if (email.length > 0) {
            setSuccessButton(true);
        } else {
            setSuccessButton(false);
        }
    }, [email]);

    const handleLogin = async (e) => {
        if (!successButton) {
            showToast("Email не заполнен", "warn", 3000);
            return;
        }
        e.preventDefault();

        setLoading(true);

        const requestBody = {
            username: email,
            password: "",
            deviceId: "1",
        };

        try {
            const response = await fetch(`${config.app.host}/api/v1/repassword`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Ошибка");
            }

            showToast("На почту отправлен код для сброса пароля", "success", 5000);
            navigate("/restore");
        } catch (err) {
            showToast(err.message, "error", 3000);
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div className={styles.container}>
            <h3>Восстановление пароля</h3>
            <div className={styles.form}>
                E-mail
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите E-mail"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <div className={styles.delimeterStyle}></div>

                <button
                    className={successButton ? styles.buttonContinueOn : styles.buttonContinue}
                    onClick={handleLogin}
                >
                    {loading ? "Подождите..." : "Запросить код"}
                </button>
                <button
                    className={styles.backButton}
                    onClick={handleBack}
                >
                    Назад
                </button>
            </div>
        </div>
    );
};

export default ForgotRequest;